import { Typegroup_service } from "../services/Typegroup.service"
import { Operator_service } from "../services/Operator_service"
import { Report_promotion_service } from "../services/Report_promotion_service"
import { MessageBox, Loading } from 'element-ui'
const moment = require("moment");
const state = {
  month_th : [ "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน ", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม" ],
  service_type : {
    mobile : "โทรศัพท์เคลื่อนที่",
    broadband : "อินเทอร์เน็ตความเร็วสูงประจำที่"
  },
  report_type : {
    price : "ค่าบริการเหมาจ่ายตามสิทธิ์การใช้งาน (บาท)",
    download_speed : "ความเร็วดาวน์โหลด (Mbps)",
    upload_speed : "ความเร็วอัปโหลด (Mbps)",
    usage : "ปริมาณผู้ใช้งานแพ็กเกจ (ราย)",
    viewer : "ปริมาณผู้เข้าชม (ครั้ง)",
    voice_amount : "ปริมาณการโทร (นาที)",
    sms_amount : "ปริมาณการส่งข้อความ SMS (ข้อความ)",
    mms_amount : "ปริมาณการส่งรูปภาพ MMS (ข้อความ)",
    internet_mb : "ปริมาณอินเทอร์เน็ต (MB)",
    internet_gb : "ปริมาณอินเทอร์เน็ต (GB)",
    voice_avg : "อัตราค่าบริการเฉลี่ยบริการเสียง (บาท/นาที)",
    sms_avg : "อัตราค่าบริการเฉลี่ยบริการส่งข้อความ (บาท/ข้อความ)",
    mms_avg : "อัตราค่าบริการเฉลี่ยบริการส่งรูปภาพ (บาท/ข้อความ)",
    internet_avg : "อัตราค่าบริการเฉลี่ยบริการอินเทอร์เน็ต (บาท)",
    voice_fee : "อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการเสียง (บาท/นาที)",
    sms_fee : "อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการส่งข้อความ (บาท/ข้อความ)",
    mms_fee : "อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการส่งรูปภาพ (บาท/ข้อความ)",
    internet_fee : "อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการอินเทอร์เน็ต (บาท/MB)"
  },
  report_unit : {
    price : "บาท",
    download_speed : "Mbps",
    upload_speed : "Mbps",
    usage : "ราย",
    viewer : "ครั้ง",
    voice_amount : "นาที",
    sms_amount : "ข้อความ",
    mms_amount : "ข้อความ",
    internet_mb : "MB",
    internet_gb : "GB",
    voice_avg : "บาท/นาที",
    sms_avg : "บาท/ข้อความ",
    mms_avg : "บาท/ข้อความ",
    internet_avg : "บาท/MB",
    voice_fee : "บาท/นาที",
    sms_fee : "บาท/ข้อความ",
    mms_fee : "บาท/ข้อความ",
    internet_fee : "บาท/MB"
  },
  provider_group : [],
  provider_list : [],
  prototype : {
    pie: {
      chart: {
        type: 'pie'
      },
      title: {
        text: ''
      },
      series: [{
          name: 'สัดส่วนร้อยละ',
          colorByPoint: true,
          data: [{
              name: 'Pre-Paid',
              y: 41.41,
              sliced: false,
              selected: false
          }, {
              name: 'Post-Paid',
              y: 17.71
          }, {
              name: 'On-Top',
              y: 40.89
          }],
          showInLegend: true,
          allowPointSelect: true
      }],
      plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
                enabled: false
            },
            showInLegend: true
        }
      },
    },
    column : {
      chart: {
          type: 'column'
      },
      title: {
          text: 'PREPAID',
          margin: 50
      },
      subtitle: {
          text: 'ประเภท Prepaid'
      },
      xAxis: {
          categories: ['Jan'],
          crosshair: true,
          title: {
            text: 'รหัสรายการส่งเสริมการขาย',
            // text: 'ชื่อรายการส่งเสริมการขาย',
          },
      },
      yAxis: {
          min: 0,
          title: {
              text: ''
          }
      },
      tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>'+'<td style="padding:0"><b>{point.y}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
      },
      plotOptions: {
          column: {
              pointPadding: 0.2,
              borderWidth: 0
          }
      },
      series: [{
          name: 'Tokyo',
          data: [49.9, 0, 106.4, 129.2]
      }],
      credits: {
        enabled: false
      }
    },
    bar : {
      chart: {
          type: 'bar'
      },
      title: {
          text: '',
          margin: 50
      },
      subtitle: {
          text: ''
      },
      xAxis: {
          categories: [],
          title: {
            text: 'รหัสรายการส่งเสริมการขาย', 
            // text: 'ชื่อรายการส่งเสริมการขาย',
          }
      },
      yAxis: {
        min:0 ,
        title: {
          text: ''
        },
        pointInterval: 5,
        tickInterval: undefined
      },
      tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: ' <tr><td colspan="2">{series.points[point.index]}<td><tr>'+'<tr><td style="color:{series.color};padding:0">{series.name}: </td>'+'<td style="padding:0"><b>{point.y}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            formatter: function() {
              return formatNumber(this.y)
            },
            style : {
              fontSize: '8px'
            },
            overflow: "allow",
            crop: false,
            allowOverlap: true
          }
        }
      },
      legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          x: -40,
          y: 80,
          floating: true,
          borderWidth: 1,
          backgroundColor: '#FFFFFF',
          shadow: true
      },
      exporting: {
        buttons: {
          contextButton:{
              menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]
          }
        }
      },
      credits: {
          enabled: false
      },
      series: []
    }
  },
  charts : [],
  data_table : [],
  displayChart : false,
  displayText : false,
  displayTable : false
}
const actions = {

  async getGroupCompany({commit},type){
    let obj = { provider_type : type}
    let result = await Typegroup_service.getGroupList(obj)
    if(result.status === 200){
      commit('PROVIDER_GROUP',result.data)
    }else {
      MessageBox.confirm(result.message, 'แจ้งเตือน', {
          confirmButtonText: 'ตกลง',
          showCancelButton: false,
          type: 'warning'
      })
    }
  },

  async getProviderByType({commit},type){
    let result = await Operator_service.getProviderList(type)
    if(result.status === 200){
      commit('PROVIDER_LIST',result.data)
    }else {
      MessageBox.confirm(result.message, 'แจ้งเตือน', {
          confirmButtonText: 'ตกลง',
          showCancelButton: false,
          type: 'warning'
      })
    }
  },

  async setChartData({commit,state},formdata){
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    let result = formdata.service_type == 'mobile' ? await Report_promotion_service.getMobileRanking(formdata) : await Report_promotion_service.getBroadbandRanking(formdata)
    if(result.status === 200){
      let chart_status = result.data.length ? true : false
      commit('SET_CHART_STATUS',chart_status)
      commit('SET_TABLE_STATUS', formdata.display_table)
      let qrydata = result.data
      let obj = {}
      let date_title = ""
      let table_data = [['รหัสรายการส่งเสริมการขาย','ชื่อรายการส่งเสริมการขาย','ผู้ให้บริการ',state.report_unit[formdata.report_type]]]
      switch(formdata.date_type){
        case 'month' :
          date_title = " เดือน"+state.month_th[moment(formdata.month).month()]+' ปี พ.ศ. '+parseInt(moment(formdata.month).year()+543)
          break
        case 'quarter' :
          date_title = " ไตรมาสที่ "+formdata.quarter_no+" ปี พ.ศ. "+parseInt(moment(formdata.quarter).year()+543)
          break
        case 'year' :
          date_title = " ปี พ.ศ. "+parseInt(moment(formdata.year).year()+543)
          break
        default :
          date_title = ""
          break
      }
      switch(formdata.chart_type){
        case 'column' :
          obj.title = "รายงานจัดอันดับรายการส่งเสริมการขาย"+state.report_type[formdata.report_type]+date_title
          // obj.subtitle = "ประเภท เปรียบเทียบ"+state.report_type[formdata.report_type]
          obj.categories = []
          obj.seriesName = state.report_type[formdata.report_type]
          obj.seriesData = []
          for(let item of qrydata){
            obj.categories.push(item.promotion_code)
            // obj.categories.push(item.promotion_name_th)
            obj.seriesData.push({y:item.amount, label:item.promotion_name_th})
            table_data.push([item.promotion_code,item.promotion_name_th,item.brand_name_th,item.amount])
          }
          obj.unit = state.report_unit[formdata.report_type]
          commit('SET_COLUMN_DATA',obj)
          setTimeout(function(){ loadingInstance.close() }, 250);
          break
        case 'bar' :
          obj.title = "รายงานจัดอันดับรายการส่งเสริมการขาย"+state.report_type[formdata.report_type]+date_title
          // obj.subtitle = "ประเภท เปรียบเทียบ"+state.report_type[formdata.report_type]
          obj.categories = []
          obj.seriesName = state.report_type[formdata.report_type]
          obj.seriesData = []
          obj.seriesDetail = []
          for(let item of qrydata){
            obj.categories.push(item.promotion_code)
            // obj.categories.push(item.promotion_name_th)
            obj.seriesData.push({y:item.amount, label:item.promotion_name_th})
            obj.seriesDetail.push(item.promotion_name_th)
            table_data.push([item.promotion_code,item.promotion_name_th,item.brand_name_th,item.amount])
          }
          obj.minHeight = formdata.limit*18
          obj.unit = state.report_unit[formdata.report_type]
          commit('SET_BAR_DATA', obj)
          setTimeout(function(){ loadingInstance.close() }, 250);
          break
      }
      commit('SET_DATA_TABLE', table_data)
    }else{
      setTimeout(function(){ loadingInstance.close() }, 250);
      MessageBox.confirm(result.message, 'แจ้งเตือน', {
        confirmButtonText: 'ตกลง',
        showCancelButton: false,
        type: 'warning'
      })
    }
  }

};

const mutations = {
  PROVIDER_GROUP(state,data){
    state.provider_group = data
  },
  PROVIDER_LIST(state,data){
    state.provider_list = data
  },
  SET_COLUMN_DATA(state,data){
    state.charts = []
    let column = JSON.parse(JSON.stringify(state.prototype.column))
        column.title.text = data.title
        column.subtitle.text = data.subtitle
        column.xAxis.categories = data.categories
        column.yAxis = {
          title : {
            text : data.unit
          }
        }
        column.series = [{
          name : data.seriesName,
          data : data.seriesData
        }]
        column.tooltip = {
          formatter: function() {
              return '<b>' + this.y + ' ' + data.unit + '</b><br><b>' + this.point.label + '</b>';
          }
        }
    state.charts.push(column)
  },
  SET_BAR_DATA(state,data){
    state.charts = []
    let bar = JSON.parse(JSON.stringify(state.prototype.bar))
        bar.legend = {}
        bar.title.text = data.title
        bar.subtitle.text = data.subtitle
        bar.xAxis.categories = data.categories
        bar.yAxis = {
          title : {
            text : data.unit
          },
        }
        bar.series = [{
          name : data.seriesName,
          data : data.seriesData,
          points : data.seriesDetail
        }]
        bar.tooltip = {
          formatter: function() {
              return '<b>' + formatNumber(this.y) + ' ' + data.unit + '</b><br><b>' + this.point.label + '</b>';
              // return '<b>' + formatNumber(this.y) + ' ' + data.unit + '</b><br><b>' + this.x + '</b>';
          }
        }
        bar.chart.scrollablePlotArea = {
          minHeight: data.minHeight
        }
        bar.plotOptions ={
          bar: {
            dataLabels: {
              enabled: true,
              formatter: function() {
                return formatNumber(this.y)
              },
              style : {
                fontSize: '10px'
              },
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          }
        },
    state.charts.push(bar)
  },
  SET_CHART_STATUS(state,status){
    state.displayChart = status
    state.displayText = !status
  },
  SET_TABLE_STATUS(state, status){
    state.displayTable = status
  },
  SET_DATA_TABLE(state, data){
    state.data_table = data
  }
}

function formatNumber(num) {
  if (num >= 10) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  } else {
    return num;
  }
}

export const Report_ranking = {
  namespaced: true,
  state,
  actions,
  mutations
};
